<template>
  <v-container class="pa-6" style="max-width: 640px">
    <v-card class="pa-4">
      <v-card-title>Exclusão de conta e dados</v-card-title>
      <v-card-text>
        <p>
          Você pode solicitar a exclusão da sua conta SCN Revolution e dos
          dados associados a qualquer momento.
        </p>

        <h3 class="mt-4">Como excluir sua conta</h3>
        <ol>
          <li>Acesse o app ou o portal e faça login normalmente;</li>
          <li>Vá em <strong>Configuração</strong>;</li>
          <li>
            Toque em <strong>"Excluir minha conta"</strong> e confirme.
          </li>
        </ol>
        <p>
          Se você estiver logado neste navegador agora, também pode excluir
          sua conta diretamente por aqui:
        </p>
        <v-btn
          v-if="isLoggedIn"
          color="error"
          outlined
          @click="dialogDelete = true"
        >
          Excluir minha conta agora
        </v-btn>

        <h3 class="mt-4">Não consegue fazer login?</h3>
        <p>
          Entre em contato com o nosso suporte informando o e-mail ou CPF
          cadastrado, para que possamos localizar e excluir sua conta.
        </p>

        <h3 class="mt-4">O que é excluído</h3>
        <p>
          Ao excluir sua conta, ela é desativada e seu acesso é bloqueado
          imediatamente. Dados pessoais (nome, e-mail, CPF, telefone,
          endereço, documentos) deixam de ser exibidos ou utilizados.
        </p>

        <h3 class="mt-4">O que é retido</h3>
        <p>
          Registros financeiros (transações, saldo e histórico de pagamentos)
          podem ser retidos pelo período exigido pela legislação fiscal e de
          prevenção à lavagem de dinheiro, mesmo após a exclusão da conta.
        </p>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogDelete" max-width="400">
      <v-card>
        <v-card-title>Confirmar exclusão</v-card-title>
        <v-card-text>
          Tem certeza que deseja excluir sua conta? Essa ação não pode ser
          desfeita.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">Cancelar</v-btn>
          <v-btn color="error" @click="confirmDelete">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      dialogDelete: false
    };
  },
  computed: {
    isLoggedIn() {
      return !!localStorage.token;
    }
  },
  methods: {
    ...mapActions(["deleteAccount"]),
    confirmDelete() {
      this.dialogDelete = false;
      this.deleteAccount();
    }
  }
};
</script>
